import { gql } from '@apollo/client';

export const STOP_CLIENT_SESSION = gql`
  mutation stopClientSession($id: Int!, $ignorePause: Boolean) {
    stopClientSession(id: $id, ignorePause: $ignorePause) {
      id
      hosts {
        host {
          alias
        }
      }
      payment {
        id
        sum
        method
        client_session {
          hosts {
            finished_at
            started_at
            host {
              alias
            }
          }
          started_at
          finished_at
        }
        client {
          uuid
          nickname
          phone
        }
        card_sum
        cash_sum
        items {
          id
          amount
          type
          sum
          entity {
            ... on Service {
              id
              title
              cost
              vat
              tax_system
            }
            ... on Good {
              id
              title
              cost
              amount
              vat
              tax_system
            }
            ... on Tariff {
              id
              title
            }
          }
        }
        status
        sum
      }
      status
      time_left
      started_at
      finished_at
      total_cost
      elapsed
    }
  }
`;
